import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

type TabActionsContextType = {
  setActions: (actions: ReactNode) => void;
};

export const TabActionsContext = createContext<TabActionsContextType | null>(null);

export const useTabActions = () => useContext(TabActionsContext);
